export default "__VITE_ASSET__XzDoDhkA__"